const BotContentPage = ({ bot }) => {
  return <div className="container" style={{ marginTop: 80, marginBottom: 80 }} dangerouslySetInnerHTML={{ __html: bot.content }} />;
};

export default BotContentPage;
